import { useBulkUserRoleDelete } from "shared/Role/useDeleteUserRole";

import { UserViewBinding } from "../../../types";
import { BULK_ACTION_NAMES, BULK_ACTION_RESULTS_TITLE } from "../constants";
import { UserRolesActionItemForBulkActions } from "./types";
import { UserRolesBulkActions } from "../types";

const useDeleteUserRolesBulkAction = (): UserRolesActionItemForBulkActions => {
  const [deleteUserRole] = useBulkUserRoleDelete();

  return {
    key: UserRolesBulkActions.Delete,
    title: BULK_ACTION_NAMES[UserRolesBulkActions.Delete],
    resultTitle: BULK_ACTION_RESULTS_TITLE[UserRolesBulkActions.Delete],
    condition: () => ({ result: true }),
    mutation: (roleBinding: UserViewBinding) => deleteUserRole({ id: roleBinding.id }),
  };
};

export default useDeleteUserRolesBulkAction;
